/**
 * @author        calvin@zumper.com (Calvin Yau)
 * @copyright     Copyright (c) 2020, Zumper
 * @description   media bizo Vimeo selectors
 */

import type { Media } from '@zcode/bizos'
import { memoizeSelector } from '@zcode/memoizers'
import { compose } from 'redux'
import { buildStaticImageUrl } from '../../../utils/image'

const VIMEO_ID_REGEX_EXP = /^.*vimeo.com\/video\/(\d+)/
const VIMEO_LOGO_PATH = 'img/shared/logo/vimeo_logo.png'

export const selectVimeoId = memoizeSelector((media: Media | undefined) => {
  const { isVideo, originUrl } = media || {}
  const vimeoMatch = originUrl ? originUrl.match(VIMEO_ID_REGEX_EXP) : null
  if (isVideo && vimeoMatch && vimeoMatch[1]) {
    return vimeoMatch[1]
  }

  return null
})

export const selectVimeoUrl = memoizeSelector((media: Media | undefined) => {
  if (selectVimeoId(media) && media?.originUrl) {
    return media.originUrl
  }
  return null
})

export const selectVimeoThumbnail = compose(
  (id) => (id ? buildStaticImageUrl({ url: VIMEO_LOGO_PATH, h: 66, w: 66 }) : null),
  selectVimeoId
)

export const selectVimeoStandardImage = compose(
  (id) => (id ? buildStaticImageUrl({ url: VIMEO_LOGO_PATH, h: 480, w: 640 }) : null),
  selectVimeoId
)

export const selectVimeoMaxResImage = compose(
  (id) => (id ? buildStaticImageUrl({ url: VIMEO_LOGO_PATH, h: 960, w: 1280 }) : null),
  selectVimeoId
)
